import { Layers, ShieldCheck, Activity, Frame, Headset } from "lucide-react";
import { Reveal, SectionHead } from "../Bits";
import { BENEFITS } from "../../lib/site";

const ICONS = { Layers, ShieldCheck, Activity, Frame, Headset };

const WhyMako = () => (
  <section data-testid="home-why" className="bg-white py-20 lg:py-32">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <Reveal>
        <SectionHead
          eyebrow="Why MAKO"
          title="Built around the way you train"
          copy="Five principles that shape every surface system we plan, from a single training zone to a complete facility."
        />
      </Reveal>

      <div className="mt-14 grid gap-px border border-[#111111]/10 bg-[#111111]/10 sm:grid-cols-2 lg:mt-20 lg:grid-cols-5">
        {BENEFITS.map((b, i) => {
          const Icon = ICONS[b.icon];
          return (
            <Reveal key={b.title} delay={i * 0.07}>
              <div
                data-testid={`benefit-${b.title.toLowerCase().split(" ")[0]}`}
                className="group h-full bg-white p-8 transition-colors duration-500 hover:bg-[#F5F5F2] lg:p-9"
              >
                <Icon
                  className="h-6 w-6 text-[#0F4C81] transition-transform duration-500 group-hover:-translate-y-1"
                  strokeWidth={1.5}
                />
                <p className="mako-label mt-8 text-[#111111]">{b.title}</p>
                <p className="mt-4 text-sm leading-relaxed text-[#3B3B3B]">{b.copy}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default WhyMako;
